export default __webpack_public_path__ + "locales/sr-Cyrl-RS/PeopleTranslations.json?hash=a87268f224165b9c93fcea83384b603c";